import { render, staticRenderFns } from "./noteStaDialog.vue?vue&type=template&id=fd5e9ca2&scoped=true&"
import script from "./noteStaDialog.vue?vue&type=script&lang=js&"
export * from "./noteStaDialog.vue?vue&type=script&lang=js&"
import style0 from "./noteStaDialog.vue?vue&type=style&index=0&id=fd5e9ca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5e9ca2",
  null
  
)

export default component.exports